// API configuration
// In development, React app runs on :3000 and proxies API requests to :5000
// Images are served from Express server on :5000, so we need the full URL in dev
// In production, if REACT_APP_API_URL is set, use it (for split deployments)
// Otherwise, use relative URLs (same origin)

const getBaseUrl = () => {
  // If explicitly set, use it (for split frontend/backend deployments)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // In development, use localhost:5000
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5000';
  }
  // In production, same origin - use relative URLs
  return '';
};

const API_BASE_URL = getBaseUrl();

export const getApiUrl = (path) => {
  return `${API_BASE_URL}${path}`;
};

export const getImageUrl = (imagePath) => {
  // Images are served from Express server
  // In dev: need full URL (localhost:5000)
  // In prod: use API_BASE_URL (empty string = relative, or full URL if split deployment)
  return `${API_BASE_URL}${imagePath}`;
};
